// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Status_wrapper__nLMCI","iconWrapper":"Status_iconWrapper__2t130","descriptionWrapper":"Status_descriptionWrapper__1kOAY","headingWrapper":"Status_headingWrapper__1ZgfB"};